<mat-dialog-content class="mat-typography">
  <div style="display: flex; justify-content: space-between; flex-direction: row;">
    <h2 mat-dialog-title><strong> Permisos </strong></h2>
    <div
      style="width: 30px; height: 30px; border-radius: 50%; display: flex; justify-content: center; align-items: center; cursor: pointer;"
      class="mat-elevation-z3" (click)="dialogRef.close()"><i class="fa fa-times "></i></div>
    </div>

    @if (tipoRedireccion=='nuevo') {
      <div>
        <mat-horizontal-stepper linear="true">
          <mat-step [stepControl]="firtsForm">
            <ng-template matStepLabel>Selección</ng-template>
            <form [formGroup]="firtsForm">
              <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 15px;">
                <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
                <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
                  matStepperNext><i class="fa fa-arrow-right"></i></button>
                </div>
                <div style="display: none">
                  <mat-form-field>
                    <mat-label>Selección</mat-label>
                    <input autocomplete="off" type="text" formControlName='selecion' matInput required>
                  </mat-form-field>
                </div>
                <data-table [columns]='columnasUsuarios' [configuration]='configurationUsuarios'
                  (clickRow)='clickFilaUsuarios($event)'
                  [params]="[{ id:'state', value: 1  }]" [url]='urlGetUsuarios'>
                </data-table>
              </form>
            </mat-step>
            <mat-step [stepControl]="FormPermisos">
              <ng-template matStepLabel>Informacion</ng-template>
              <form [formGroup]="FormPermisos" (ngSubmit)="FormPermisos.valid?saveForm(FormPermisos.value):errorMessage()">
                <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 5px;">
                  <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
                    matStepperPrevious><i class="fa fa-arrow-left"></i></button>
                    <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
                    @if (usuario) {
                      <h3 style="margin: 10px"><strong>usuario: {{usuario}}</strong> </h3>
                    }
                    <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button matStepperNext
                      type="submit"><i class="fa fa-arrow-right"></i></button>
                    </div>
                    <div style='display: flex; width: 100%; '>
                      <div style='flex:12'>
                        <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport">
                          <div class='first-row'>
                            <div class='row-item'>
                              <mat-form-field [appOpenDatepickerOnClick]="picker">
                                <mat-label>Fecha</mat-label>
                                <input matInput [matDatepicker]="picker" autocomplete="off" matInput formControlName='date'
                                  required>
                                <mat-datepicker-toggle matIconSuffix [for]="picker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #picker [touchUi]='movil?true:false'></mat-datepicker>
                                <mat-error>Campo requerido</mat-error>
                              </mat-form-field>
                            </div>
                            <div class='row-item'>
                              <mat-form-field [appOpenDatepickerOnClick]="pickerStart">
                                <mat-label>Fecha inicio</mat-label>
                                <input matInput [matDatepicker]="pickerStart" autocomplete="off" matInput
                                  formControlName='startDate' (dateChange)="changeDate($event, 'inicio')" required>
                                <mat-datepicker-toggle matIconSuffix [for]="pickerStart">
                                </mat-datepicker-toggle>
                                <mat-datepicker #pickerStart [touchUi]='movil?true:false'></mat-datepicker>
                                <mat-error>Campo requerido</mat-error>
                              </mat-form-field>
                            </div>
                            <div class='row-item'>
                              <mat-form-field [appOpenDatepickerOnClick]="pickerEnd">
                                <mat-label>Fecha Final</mat-label>
                                <input matInput [matDatepicker]="pickerEnd" autocomplete="off" matInput
                                  formControlName='finalDate' (dateChange)="changeDate($event, 'final')" required>
                                <mat-datepicker-toggle matIconSuffix [for]="pickerEnd">
                                </mat-datepicker-toggle>
                                <mat-datepicker #pickerEnd [touchUi]='movil?true:false'></mat-datepicker>
                                <mat-error>Campo requerido</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class='default-row'>
                            <div class='row-item'>
                              <mat-form-field>
                                <mat-label>Duración</mat-label>
                                <input [readonly]='duracion==null' autocomplete="off" type="text" formControlName='duration'
                                  matInput placeholder="Duracion" required>
                              </mat-form-field>
                            </div>
                            <div class='row-item'>
                              <!-- Responsable // genered by-->
                              <combos [configuration]='combosConfigResponsable' [required]="true" [filter]="true"
                                (changeOptionDataComplete)="ValueResponsable($event)" [control]="FormPermisos.get('approvedBy')">
                              </combos>
                            </div>
                            <div class='row-item'>
                              <mat-form-field>
                                <mat-label>Remunerado:</mat-label>
                                <mat-select formControlName="remuneration" required>
                                  <mat-option value='1'>
                                  SI</mat-option>
                                  <mat-option value='0'>
                                  NO</mat-option>
                                </mat-select>
                                <mat-error>Campo requerido</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class='default-row'>
                            <div class='row-item'>
                              <mat-form-field>
                                <mat-label>Descripción</mat-label>
                                <input autocomplete="off" type="text" formControlName='description' matInput #descripcion
                                  maxlength="1024" placeholder="Descripción" required>
                                <mat-hint>{{descripcion.value.length}}/1024</mat-hint>
                                <mat-error>Campo requerido</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </cdk-virtual-scroll-viewport>
                      </div>
                    </div>
                  </form>
                </mat-step>
                <mat-step>
                  <ng-template matStepLabel>Finalizar</ng-template>
                  <div class="mat-elevation-z2" style="display: flex; justify-content: space-between; margin-bottom: 30px;">
                    <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
                      matStepperPrevious><i class="fa fa-arrow-left"></i></button>
                      <button class="mat-elevation-z2" mat-mini-fab color="warn" (click)="save()">
                        <mat-icon>save</mat-icon>
                      </button>
                    </div>
                    <div style="width: 100%; display: flex; flex-direction: row;">
                      <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
                    </div>
                  </mat-step>
                </mat-horizontal-stepper>
              </div>
            }

            @if (tipoRedireccion=='visualizar') {
              <div style="width: 100%; display: flex; flex-direction: row;">
                <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
              </div>
            }

          </mat-dialog-content>

          <ng-template #SummaryInformation>

            <div style="width: 50%; height: 100%; display: flex; flex-direction: column; text-align: center; align-self: center;">
              <div>
                <img src="{{imageSrc}}" [ngStyle]="sizePicture">
                <h3 style="margin-top: 15px;"><strong>Nombre: </strong> {{nombreSelecionado}}</h3>
                <h3><strong>usuario: </strong> {{usuario}}</h3>
              </div>
            </div>

            <div style="text-align: center; width: 50%; height: 100%;">
              <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z1">
                <mat-tab label="">
                  <mat-list>

                    <mat-list-item>
                      <span matListItemTitle>Fecha</span>
                      {{ fechaLabel }}
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item>
                      <span matListItemTitle>Fecha Inicio</span>
                      {{ inicio }}
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item>
                      <span matListItemTitle>Fecha Fin</span>
                      {{ final }}
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item>
                      <span matListItemTitle>Duración</span>
                      {{ duracion }}
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item>
                      <span matListItemTitle>Aprobado Por</span>
                      {{ aprobadoLabel }}
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item>
                      <span matListItemTitle>Remunerado</span>
                      {{ remuneracionLabel }}
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item>
                      <span matListItemTitle>Descripción</span>
                      {{ descripcionLabel }}
                    </mat-list-item>
                    <mat-divider></mat-divider>

                  </mat-list>
                </mat-tab>
              </mat-tab-group>
            </div>

          </ng-template>